import React from 'react';
import { Helmet } from 'react-helmet-async';
import HospitalManagement from '../components/HospitalManagement';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Hospital Management Software', item: 'https://wayug.com/hospital-management-software' },
  ],
};

const softwareSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Mediway NextGen Hospital Management Software',
  operatingSystem: 'Web, Windows, Android, iOS',
  applicationCategory: 'HealthApplication',
  offers: {
    '@type': 'Offer',
    price: '80000',
    priceCurrency: 'INR',
  },
  description: 'Enterprise ABDM-ready, NABH-compliant Hospital Information System (HIS) powering clinics, nursing homes, and multi-specialty hospitals in Delhi NCR & India.',
  author: {
    '@type': 'Organization',
    name: 'Wayug Infotech Solutions',
    url: 'https://wayug.com',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Is Mediway HMS compliant with Ayushman Bharat (ABDM)?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Mediway HMS is fully integrated with ABDM (M1, M2, M3 certified workflows), enabling seamless ABHA ID creation, health record linking, and national health stack compliance.',
      },
    },
    {
      '@type': 'Question',
      name: 'Does the software support NABH accreditation auditing?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Mediway maintains immutable audit logs, incident reporting modules, patient safety checklists, and electronic medical records (EMR) designed specifically to meet NABH guidelines.',
      },
    },
    {
      '@type': 'Question',
      name: 'How much does Mediway Hospital Management Software cost in India?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Pricing starts from ₹80,000 for single-clinic/nursing home setups and scales based on bed capacity and optional modules.',
      },
    },
  ],
};

export default function HospitalManagementPage() {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>Hospital Management Software India | ABDM &amp; NABH Compliant HMS – Wayug</title>
        <meta
          name="description"
          content="Enterprise Hospital Management Software (HMS/HIS) in Delhi NCR &amp; India. ABDM compliant, NABH ready, OPD/IPD billing, LIS, Pharmacy &amp; Tally integration. Book a demo."
        />
        <link rel="canonical" href="https://wayug.com/hospital-management-software" />
        <meta property="og:title" content="Hospital Management Software India | Mediway HMS – Wayug Infotech" />
        <meta
          property="og:description"
          content="Power your hospital or clinic with ABDM-ready, NABH-compliant Hospital Information Systems. Complete OPD, IPD, Billing &amp; Pharmacy automation."
        />
        <meta property="og:url" content="https://wayug.com/hospital-management-software" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(softwareSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <HospitalManagement />
    </div>
  );
}
